import React from "react";
import { QRCode } from "react-qr-svg";
import CheckItems from "../Body/CheckDetails/QRCheckItems";
import classes from "./QRComponent.module.css";
import constants from "../../../../globalization";
import closeIcon from "../../../../assets/images/Fireboard/close.png"

const QRComponent = (props) => {
  const {
    items,
    qrValue,
    unpaid,
    closePopup,
    currency = '$',
    joinCheck,
  } = props || {};
  return (
    <div className={classes.container}>
      <div className={classes.qrContainer}>
        <QRCode
          bgColor="#FFFFFF"
          fgColor="#000000"
          level="Q"
          style={{ width: "42.66vw" }}
          value={qrValue}
        />
      </div>
      {!joinCheck ? (
        <div className={classes.checkDetailsContainer}>
          <div className={classes.closeContainer}>
            <button type="submit" onClick={closePopup} className={classes.closeBtn}>
              <img src={closeIcon} alt="close" className={classes.closeIconStyle} />
            </button>
          </div>
          <CheckItems items={items} />

          <div className={classes.dueContainer}>
            <span className={classes.textStyle}>{constants.totalDueWithoutDollar}</span>
            <span className={classes.textStyle}>{currency}{unpaid ? unpaid.toFixed(2) : "0.00"}</span>
          </div>
        </div>) : (
          <div className={classes.checkDetailsContainer}>
            <div className={classes.closeContainer}>
              <button type="submit" onClick={closePopup} className={classes.closeBtn}>
                <img src={closeIcon} alt="close" className={classes.closeIconStyle} />
              </button>
            </div>
            <div className={classes.align}>
              <h3 className={classes.scanText}>SCAN THIS QR CODE USING YOUR PHONE'S CAMERA</h3>
              <h3 className={classes.scanText}>OR</h3>
              <h3 className={classes.scanText}>GO TO</h3>
              <h3 className={classes.scanText}>HTTPS://SCANQR.IO</h3>
            </div>
          </div>
        )}
      <span className={classes.qrUrl}>{qrValue}</span>
    </div>
  );
};

export default QRComponent;
